import React, { useEffect, useState } from 'react';
import "../styles/hosteldata.css";
import "../Hostal/hostal.jpg";
import "../Hostal/Watchmen.jpeg";
import "../Hostal/Room Services.jpeg";
import "../Hostal/247 Water Supply.jpg";
import "../Hostal/Mess Hall.jpg";
import "../Hostal/Medical Assistance.png";
import "../Hostal/Sports Facilities.jpg";
import "../Hostal/Study Room.avif";

const HostelData = () => {
  const [hostelInfo, setHostelInfo] = useState({
    totalSeats: 0,
    availableSeats: 0,
    occupiedSeats: 0
  });
  
  const [currentSeats, setCurrentSeats] = useState({
    totalSeats: 0,
    availableSeats: 0,
    occupiedSeats: 0
  });

  // Fetch hostel information from the PHP backend when component mounts
  useEffect(() => {
    fetch('https://gptkpm.in/backend/hostel/code/get_hostel_info.php')  // Update with the correct path to PHP file
      .then(response => response.json())
      .then(data => {
        setHostelInfo({
          totalSeats: data.total_seats,
          availableSeats: data.available_seats,
          occupiedSeats: data.occupied_seats
        });

        // Animate the values from 0 to the actual numbers over 10 seconds
        animateValues(data.total_seats, data.available_seats, data.occupied_seats);
      })
      .catch(error => console.error('Error fetching data:', error));
  }, []);

  // Function to animate values from 0 to the target value over 10 seconds
  const animateValues = (totalSeats, availableSeats, occupiedSeats) => {
    let totalSeatsValue = 0;
    let availableSeatsValue = 0;
    let occupiedSeatsValue = 0;

    // Update every 200ms (10 seconds / 50 updates = 200ms per update)
    const interval = setInterval(() => {
      if (totalSeatsValue < totalSeats) totalSeatsValue++;
      if (availableSeatsValue < availableSeats) availableSeatsValue++;
      if (occupiedSeatsValue < occupiedSeats) occupiedSeatsValue++;

      setCurrentSeats({
        totalSeats: totalSeatsValue,
        availableSeats: availableSeatsValue,
        occupiedSeats: occupiedSeatsValue
      });

      // Clear the interval once all values reach their target
      if (totalSeatsValue >= totalSeats && availableSeatsValue >= availableSeats && occupiedSeatsValue >= occupiedSeats) {
        clearInterval(interval);
      }
    }, 100); // 200ms interval to complete in 10 seconds
  };

  return (
    <div className="hostel-data-container">
      {/* Hero Section */}
      <section className="hero-section">
        <img src={require("../Hostal/hostal.jpg")} alt="Hostel Background" />
        <div className="hero-content">
          <h1>Welcome to Our Hostel</h1>
        </div>
      </section>

      {/* Hostel Information Section */}
      <section className="hostel-info-section">
        <div ><a href="http://gptkpm.thecodeon.com">
          <button className='mess-bill'>Pay mess bill</button>
          </a>
        </div>  
      </section>

      {/* Services Section */}
        <section className="services-section">
          <div className="services-container">
            <h2>Our Hostel Services</h2>
            <div className="services">
              <div className="service-item">
                <img src={require("../Hostal/Watchmen.jpeg")} alt="Watchmen" />
                <h3>Watchmen</h3>
                <p>Security personnel are available around the clock to ensure safety.</p>
              </div>
              <div className="service-item">
                <img src={require("../Hostal/24x7-Security-img.jpg")} alt="24/7 Camera Surveillance" />
                <h3>24/7 Camera Surveillance</h3>
                <p>Our hostel is under constant CCTV surveillance for your safety.</p>
              </div>
              <div className="service-item">
                <img src={require("../Hostal/Room Services.jpeg")} alt="Room Services" />
                <h3>Room Services</h3>
                <p>We provide regular cleaning and maintenance of hostel rooms.</p>
              </div>
              <div className="service-item">
                <img src={require("../Hostal/247 Water Supply.jpg")} alt="24/7 Water Supply" />
                <h3>24/7 Water Supply</h3>
                <p>Water is available at all times for your convenience and comfort.</p>
              </div>
              <div className="service-item">
                <img src={require("../Hostal/Mess Hall.jpg")} alt="Mess Hall" />
                <h3>Mess Hall</h3>
                <p>Delicious and healthy meals are served three times a day in our mess hall.</p>
              </div>
              <div className="service-item">
                <img src={require("../Hostal/Medical Assistance.png")} alt="Medical Assistance" />
                <h3>Medical Assistance</h3>
                <p>Basic medical facilities and first aid are available at all times.</p>
              </div>
              <div className="service-item">
                <img src={require("../Hostal/Sports Facilities.jpg")} alt="Sports Facilities" />
                <h3>Sports Facilities</h3>
                <p>Hostel has a sports area for activities like badminton, table tennis, and more.</p>
              </div>
              <div className="service-item">
                <img src={require("../Hostal/Study Room.avif")} alt="Study Room" />
                <h3>Study Room</h3>
                <p>A quiet space with study materials to help students focus on their academic work.</p>
              </div>
              
            </div>
          </div>
        </section>


      
    </div>
  );
};

export default HostelData;
